<template>
    <!-- 白皮书 -->
    <el-dialog
      class="white-paper-dialog"
      :visible.sync="showDialog"
      :show-close="false"
      @closed="closedDialog"
      center>
      <div class="flex-column">
        <!--<a @click="errTip">{{ $t('techWhitePaper') }}</a>-->
        <a target="_blank" :href="'https://oss.sharder.org/sharder/whitepaper/sharder-technical-whitepaper-' + whitePaperLang[$i18n.locale] + '.pdf'">{{ $t('techWhitePaper') }}</a>
        <!--<a target="_blank" :href="'https://oss.sharder.org/sharder/whitepaper/sharder-usermanual-whitepaper-' + whitePaperLang[$i18n.locale] + '.pdf'">{{ $t('comWhitePaper') }}</a>-->
        <!--<a target="_blank" :href="'https://oss.sharder.org/sharder/whitepaper/sharder-consensus-' + whitePaperLang[$i18n.locale] + '.pdf'">{{ $t('sharderWhitePaper') }}</a>-->
      </div>
    </el-dialog>
</template>

<script>
  export default {
    name: 'white-paper-dialog',
    props: {
      showDialog: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        whitePaperLang: {
          'zh-CN': 'cn',
          'en-US': 'en'
        }
      }
    },
    methods: {
      closedDialog () {
        this.$emit('closedWhitePaperDialog', false)
      },
      errTip () {
        this.$notify.info({
          title: 'message',
          message: 'White papers V3 will be released soon！'
        })
      }
    }
  }
</script>

<style lang="scss">
  @import "../../styles/common.scss";

  .white-paper-dialog {
    .el-dialog {
      width: 35%;
    }

    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding-top: 6rem;
      padding-bottom: 6rem;
    }
    .el-dialog__body a {
      width: 80%;
      height: 6rem;
      line-height: 6rem;
      padding: 0.8rem 0;
      font-size: 2rem;
      border-radius: 6rem;
      color: #FFFFFF;
      background-color: #000000;
      text-align: center;
      cursor: pointer;
      text-decoration: none;

      &:hover {
        color: $color;
      }

      &:not(:first-child) {
        margin-top: 2rem;
      }
    }
  }

  @media screen and (max-width: 1400px) {
    .white-paper-dialog .el-dialog {
      width: 60%;
    }
  }

  @media screen and (max-width: 768px) {
    .white-paper-dialog {
      .el-dialog {
        width: 80%;
      }
      .el-dialog__body a {
        width: 100%;
      }
    }
  }

</style>
